import React from "react"
import PropTypes from "prop-types"
import "./progressBar.css"

const ProgressBar = ({before, completed}) => {
  const [value, setValue] = React.useState(before);
  React.useEffect(() => {
    setValue(completed);
  }, [completed]);

  return (
    <div className="Bar">
      <div style={{ width: `${value}%` }} className="Progress" />
    </div>
  );
}

ProgressBar.propTypes = {
  completed: PropTypes.any,
  before: PropTypes.any,
}

ProgressBar.defaultProps = {
  completed: 0,
  before: 0,
}

export default ProgressBar
